import { render, staticRenderFns } from "./SwymBackInStock.vue?vue&type=template&id=60239839&scoped=true&lang=pug&"
import script from "./SwymBackInStock.vue?vue&type=script&lang=js&"
export * from "./SwymBackInStock.vue?vue&type=script&lang=js&"
import style0 from "./SwymBackInStock.vue?vue&type=style&index=0&id=60239839&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60239839",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60239839')) {
      api.createRecord('60239839', component.options)
    } else {
      api.reload('60239839', component.options)
    }
    module.hot.accept("./SwymBackInStock.vue?vue&type=template&id=60239839&scoped=true&lang=pug&", function () {
      api.rerender('60239839', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/product/SwymBackInStock.vue"
export default component.exports